import { Lookup } from '../lookup.interface';
export interface LiveWithLookup extends Lookup {
  livesWithParent?: boolean;
}
export const LiveWithTypes: { [name: string]: LiveWithLookup } = {
  fullTime: { displayValue: 'Full-time', livesWithParent: true },
  partTime: { displayValue: 'Part-time', livesWithParent: true },
  notLivingWithClient: { displayValue: 'Not living with client' },
};
